// src/redux/actions/locationActions.js

import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_LOCATIONS_REQUEST = "FETCH_LOCATIONS_REQUEST";
export const FETCH_LOCATIONS_SUCCESS = "FETCH_LOCATIONS_SUCCESS";
export const FETCH_LOCATIONS_FAILURE = "FETCH_LOCATIONS_FAILURE";

export const CREATE_LOCATION_REQUEST = "CREATE_LOCATION_REQUEST";
export const CREATE_LOCATION_SUCCESS = "CREATE_LOCATION_SUCCESS";
export const CREATE_LOCATION_FAILURE = "CREATE_LOCATION_FAILURE";

// Fetch All Locations
export const fetchVisitLocations = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_LOCATIONS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(`${BASE_URL}/v1/api/get-all-locations`, {
        headers: { Authorization: token },
      });

      if (response?.data?.meta?.status) {
        dispatch({
          type: FETCH_LOCATIONS_SUCCESS,
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: FETCH_LOCATIONS_FAILURE,
          payload: response?.data?.meta?.message || "Failed to fetch locations",
        });
        toast.error(response?.data?.meta?.message || "Failed to fetch locations");
      }
    } catch (error) {
      dispatch({
        type: FETCH_LOCATIONS_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
      toast.error("Error fetching locations");
    }
  };
};

// Create a New Location
export const createLocation = (location_name) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_LOCATION_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${BASE_URL}/v1/api/create-location`,
        { location_name },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.meta?.status) {
        dispatch({ type: CREATE_LOCATION_SUCCESS });
        toast.success("Location created successfully");

        // ✅ Refetch updated list
        dispatch(fetchVisitLocations());
      } else {
        dispatch({
          type: CREATE_LOCATION_FAILURE,
          payload: response?.data?.meta?.message || "Failed to create location",
        });
        toast.error(response?.data?.meta?.message || "Failed to create location");
      }
    } catch (error) {
      dispatch({
        type: CREATE_LOCATION_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
      toast.error("Error creating location");
    }
  };
};
